import './Scoreboard.scss';
import { gameActions } from "../Game/gameSlice";
import store, { RootState } from "../store";
import { apiSlice, useGetStatsQuery } from '../api/apiSlice'
import { useAppSelector } from '../redux';
import { getFullName } from '../Game/rpgLogic';
import { useEffect } from 'react';
import SpritesheetAsset from '../Components/SpritesheetAsset';

function Scoreboard() {

    const gameState = useAppSelector((state: RootState) => state.game)

    function handleClose() {
        store.dispatch(gameActions.hideScoreboard())
    }

    useEffect(() => {
        // to fetch every time we open the scoreboard
        store.dispatch(apiSlice.util.invalidateTags(['data']));
    }, []);

    const {
        data: data,
        isLoading: isGetLoading,
        isSuccess: isGetSuccess,
        isError: isGetError,
        error: getError,
    } = useGetStatsQuery({
        refetchOnMountOrArgChange: true
    })

    const scoreboardItems = data?.scoreboardItems || [];
    const stats = data?.stats || [];

    if (!scoreboardItems || !stats || isGetError || (scoreboardItems && scoreboardItems.length === 0)) {
        return <div className="scoreboard">
            <div className="close" onClick={handleClose}>x</div>
            <span>loading stats</span>
        </div>
    }

    function renderStat(stat: number) {
        return Number(stat.toFixed(2));
    }

    return (
        <div className="scoreboard center">
            <div className="close" onClick={handleClose}>x</div>
            <div className="text-heading button-text">Top Score</div>
            {scoreboardItems && scoreboardItems.length > 0 && scoreboardItems.map((it, i) => {
                return (
                    <div className="scoreboard-entry" key={`${i}`}>
                        <div className='scoreboard-avatar'>
                            {it.sprite && <SpritesheetAsset name={it.sprite} multiplier={1} />}
                        </div>
                        <div className={`${it?.name === getFullName(gameState.player?.name, gameState.player?.gender) ? 'active' : ''}`}>
                            {i + 1}. {it.name}[{it.level}]: {it.monsters} monsters, {it.numberOfDeaths} deaths
                        </div>
                    </div>
                );
            })}
            {stats && <>
                <div className="text-heading button-text">Stats</div>
                {<div className="scoreboard-entry">Total Players: {stats.totalPlayers}</div>}
                <div className="scoreboard-entry">Total Monsters Killed: {renderStat(stats.totalMonsterKills)}</div>
                <div className="scoreboard-entry">Total Player Deaths: {renderStat(stats.totalDeaths)}</div>
                <div className="scoreboard-entry">Total Levels reached: {renderStat(stats.totalLevels)}</div>
                <div className="scoreboard-entry">Average Balance: {renderStat(stats.averageBalance)}</div>
                <div className="scoreboard-entry">Average Bet: {renderStat(stats.averageBet)}</div>
                <div className="scoreboard-entry">Average Potions: {renderStat(stats.averagePotions)}</div>
            </>

            }


            <div className="button-text center-text" onClick={handleClose}>Ok</div>
        </div>
    );
}

export default Scoreboard;
